/**
 * Collection header — mobile read-more.
 *
 * On mobile (<=768px), the collection description is line-clamped via CSS.
 * If the clamped content overflows, a "Read more" button is injected after
 * the description and toggles a `.is-expanded` class to reveal the full text.
 *
 * On desktop the button is hidden and the clamp does not apply.
 */
(function () {
  if (window.__collectionHeaderReadmoreInit) return;
  window.__collectionHeaderReadmoreInit = true;

  var mq = window.matchMedia('(max-width: 768px)');

  function setup(desc) {
    if (desc.__readmoreInit) return;
    desc.__readmoreInit = true;

    var textItem = desc.querySelector('.collection-header__text-item');
    if (!textItem) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-header__readmore';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.hidden = true;

    btn.addEventListener('click', function () {
      var expanded = desc.classList.toggle('is-expanded');
      btn.textContent = expanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    desc.appendChild(btn);
    update(desc, textItem, btn);
  }

  function update(desc, textItem, btn) {
    if (!mq.matches) {
      btn.hidden = true;
      desc.classList.remove('is-expanded');
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      return;
    }
    // Measure against the collapsed state to decide whether the toggle
    // is needed at all.
    var wasExpanded = desc.classList.contains('is-expanded');
    desc.classList.remove('is-expanded');
    var overflows = textItem.scrollHeight - 2 > textItem.clientHeight;
    btn.hidden = !overflows;
    if (wasExpanded && overflows) {
      desc.classList.add('is-expanded');
    }
  }

  function init() {
    document.querySelectorAll('.collection-header__description').forEach(setup);
  }

  function refreshAll() {
    document.querySelectorAll('.collection-header__description').forEach(function (desc) {
      var textItem = desc.querySelector('.collection-header__text-item');
      var btn = desc.querySelector('.collection-header__readmore');
      if (textItem && btn) update(desc, textItem, btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', refreshAll);
  mq.addEventListener ? mq.addEventListener('change', refreshAll) : mq.addListener(refreshAll);
  document.addEventListener('shopify:section:load', init);
})();
